<template>
	<v-modal class="v-dialog" ref="dialog" :width="$attrs.width" :height="$attrs.height" mask>
		<div class="v-dialog-head">
			<div class="v-dialog-title">
				<v-text>{{title}}</v-text>
				<slot name="title"/>
			</div>
			<div class="v-dialog-close" @click="close">
				<slot name="close" v-if="'close' in $slots"/>
				<v-icon type="v-icon-dialog-close" v-else-if="$attrs.closable!=null"/>
			</div>
		</div>
		<div class="v-dialog-body">
			<slot/>
		</div>
		<div class="v-dialog-foot">
			<slot name="foot"/>
		</div>
	</v-modal>
</template>

<script>
export default {
  props: {
    title: {
      default: ""
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    }
  }
};
</script>

<style lang="less">
.v-dialog {
  > .v-modal-body {
    min-width: 300px;
    min-height: 120px;
    > .v-dialog-head {
      display: flex;
      > .v-dialog-title {
        flex: 1;
      }
      > .v-dialog-close {
        cursor: pointer;
        color: #999999;
      }
      > .v-dialog-close:empty {
        display: none;
      }
    }
    > .v-dialog-body {
      flex: 1;
    }
    > .v-dialog-head,
    > .v-dialog-body,
    > .v-dialog-foot {
      padding: 10px;
    }
    > .v-dialog-head:empty,
    > .v-dialog-body:empty,
    > .v-dialog-foot:empty {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/modal/dialog.vue